export default __webpack_public_path__ + "static/media/nexa-loader.0719d87c.png";